module.exports = "/_next/static/images/0873670e93bb8ea527c1302373f73a0f-cuenta.png.webp";